<div class="map-page">
  <div class="map-page__container">
    <h1 class="map-page__title">Mapa del sitio de Unipay</h1>
    <app-sitemap-grid></app-sitemap-grid>
  </div>
</div> 